import { render } from "./AppLayoutPrivate.vue?vue&type=template&id=c2b279a8&scoped=true"
import script from "./AppLayoutPrivate.vue?vue&type=script&lang=js"
export * from "./AppLayoutPrivate.vue?vue&type=script&lang=js"

import "./AppLayoutPrivate.vue?vue&type=style&index=0&id=c2b279a8&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2b279a8"]])

export default __exports__